module.exports = __webpack_public_path__ + "static/media/cx.74cec426.svg";